import {
  MANPOWER_PROFILE_FETCHING,
  MANPOWER_PROFILE_FAILED,
  MANPOWER_PROFILE_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case MANPOWER_PROFILE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case MANPOWER_PROFILE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case MANPOWER_PROFILE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
